import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import colors from '@/styles/color.scss';
import AttrRecognition from '@blade-sxp/task-management/components/visitors-portrait/attr-recognition.vue';
import AttrOutput from '@blade-sxp/task-management/components/visitors-portrait/attr-output.vue';
let VisitorsPortrait = class VisitorsPortrait extends Vue {
    switchStr;
    recognitionConfig;
    outputConfig;
    disabled;
    radios;
    // attrOutputConfig: IVisitorsPortraitConfigItem = {};
    // attrRecognitionConfig: IVisitorsPortraitConfigItem = {};
    // @Watch('recognitionConfig', { immediate: true, deep: true })
    // onRecognitionConfig(nv: IVisitorsPortraitConfigItem) {
    //   this.attrRecognitionConfig = nv;
    // }
    // @Watch('outputConfig', { immediate: true, deep: true })
    // onOutputConfig(nv: IVisitorsPortraitConfigItem) {
    //   this.attrOutputConfig = nv;
    // }
    get isActive() {
        return this.switchVal === this.active.val;
    }
    get statusText() {
        return this.switchVal === this.active.val ? this.$t('active') : this.$t('inactive');
    }
    active = {
        val: true,
        color: colors.searchYellow,
    };
    inactive = {
        val: false,
        color: colors.boardItemHover,
    };
    switchVal = this.inactive.val;
    onSwitchStr(nv) {
        this.switchVal = nv;
    }
    changeSwitch(val) {
        this.$emit('update:switchStr', this.switchVal);
    }
    changeChecked(keys) {
        this.radios.forEach((item) => {
            const isKey = keys.includes(item.key);
            item.disabled = !isKey;
        });
        const attrOutputProps = this.outputConfig.props;
        const keysLen = keys.length;
        // let hasCheck = false;
        attrOutputProps &&
            Object.keys(attrOutputProps)?.forEach((k) => {
                const prop = attrOutputProps[k];
                const val = prop?.val;
                if (keysLen === 1) {
                    prop.val = keys[0];
                }
                else if (keysLen === 0) {
                    prop.val = '';
                }
                else {
                    if (val) {
                        const isCheckedKey = keys.includes(val);
                        !isCheckedKey && (prop.val = '');
                    }
                }
            });
        this.$emit('update:radios', this.radios);
        this.$emit('update:outputConfig', this.outputConfig);
        this.$emit('update:recognitionConfig', this.recognitionConfig);
    }
    changeOutPut() {
        this.$emit('update:outputConfig', this.outputConfig);
    }
    changeDevice() {
        this.$emit('update:recognitionConfig', this.recognitionConfig);
    }
};
__decorate([
    Prop()
], VisitorsPortrait.prototype, "switchStr", void 0);
__decorate([
    Prop()
], VisitorsPortrait.prototype, "recognitionConfig", void 0);
__decorate([
    Prop()
], VisitorsPortrait.prototype, "outputConfig", void 0);
__decorate([
    Prop()
], VisitorsPortrait.prototype, "disabled", void 0);
__decorate([
    Prop()
], VisitorsPortrait.prototype, "radios", void 0);
__decorate([
    Watch('switchStr', { immediate: true })
], VisitorsPortrait.prototype, "onSwitchStr", null);
VisitorsPortrait = __decorate([
    Component({
        name: 'VisitorsPortrait',
        components: {
            AttrRecognition,
            AttrOutput,
        },
        i18n: {
            messages: {
                zh: {
                    portraitName: '访客画像',
                    active: 'Activated',
                    inactive: 'Disabled',
                    device: '设备',
                },
                en: {
                    portraitName: 'Visitors Portrait',
                    active: 'Activated',
                    inactive: 'Disabled',
                    device: 'Device',
                },
            },
        },
    })
], VisitorsPortrait);
export default VisitorsPortrait;
